import { render, staticRenderFns } from "./PopupEditDataController.vue?vue&type=template&id=fac20966&scoped=true&"
import script from "./PopupEditDataController.vue?vue&type=script&lang=js&"
export * from "./PopupEditDataController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac20966",
  null
  
)

export default component.exports